export default Object.freeze({ ANALYSIS: 'analysis', CONTROLLER: 'controller', LAB: 'lab' });
